export default __webpack_public_path__ + "static/media/Background.bb1626dc.jpg";